import React, { useState } from 'react';
import {Input} from 'antd';
import NumberFormat from 'react-number-format';
import axios from 'axios';



const useViaCep = () => {
    const buscaCep = async (cep) => {
        const ax = axios.create();
        return ax.get('https://viacep.com.br/ws/'+cep+'/json/');
    }

    return {buscaCep};
}

const InputCEP = ({
        onChange=(evt)=>{},
        setCepValido = (valido)=> {},
        loading = ()=>{}
        
    }) => {


    const [value, setValue] = useState({ 
                                        cep: '',
                                        endereco: '',
                                        bairro: '',
                                        cidade:'',
                                        cod_cidade_ibge: '',
                                        cod_estado_ibge: '',
                                        estado:''
                                    });
    const {buscaCep} = useViaCep();

    const formataCep = (val) => {
        let format = "";
        if(val.length >= 8){
            format = val.replace(/(\d{2})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1-$2')
                .replace(/(-\d{3})\d+?$/, '$1')       
        }

        if(!format){
            return val;
        }

        return format;
    }

  
    const onChangeHandle = async (evt)=> {
        const cepValue = (evt.value);
        let newValue = {
            cep: cepValue,
            endereco: '',
            bairro: '',
            cidade:'',
            cod_cidade_ibge: '',
            cod_estado_ibge: '',
            estado:''
        };
        if(newValue.cep.length == 8 ){
            try{
                loading(true);
                const result = await buscaCep(cepValue);
                const {logradouro, bairro, localidade, uf, ibge} = result.data;
                const cod_estado_ibge = ibge.substr(0, 2);
                const endereco = {
                    endereco: logradouro,
                    bairro,
                    cidade:localidade,
                    cod_cidade_ibge: ibge,
                    cod_estado_ibge,
                    estado:uf                    
                }

                newValue = Object.assign({}, {...newValue}, {...endereco});
                setCepValido(true);


            }
            catch(e){
                setCepValido(false);
                console.log('Erro ao buscar CEP', e);
            }

        } else {
            setCepValido(true);
        }
        loading(false);
        setValue(newValue);
        onChange(newValue);

        
    }

    return <NumberFormat 
            onValueChange={onChangeHandle} 
            format={formataCep} 
            customInput={Input}
            
        >
        
    </NumberFormat>

}

export {InputCEP};